import { addSideEffects, initAction } from '@poa/state';
import moment from 'moment';
import { clone } from '../shared/clone';
import { fetchDashboard, fetchNewDashboard, setDates } from './dashboard.actions';
import { DateModeCalendar, PageModeCalendar } from '../../components/table-filter';


async function fetchDashboardData(env, actions, startDate, endDate, teamLead, previousStartDate, previousEndDate) {
  try {
      const [report, reportsPrevious] = await Promise.all([
          await env.api.dashboard.fetchDashboard(startDate, endDate, teamLead),
          await env.api.dashboard.fetchDashboard(previousStartDate.unix(), previousEndDate.unix(), teamLead)
      ]);

      actions.dashboardActions.fetchDataSuccess(report, reportsPrevious);

  } catch (error) {
      console.error(error);
      actions.dashboardActions.fetchFailed();
  }
}


async function fetchDashboardProfit(env, actions, startDate, endDate, teamLead, previousStartDate, previousEndDate) {
  try {
      const [profitResponse, profitReportPrevious] = await Promise.all([
          await env.api.dashboard.fetchDashboardProfit(startDate, endDate, teamLead),
          await env.api.dashboard.fetchDashboardProfit(previousStartDate.unix(), previousEndDate.unix(), teamLead)
      ]);

      actions.dashboardActions.fetchProfitSuccess(profitResponse, profitReportPrevious);

  } catch (error) {
      console.error(error);
      actions.dashboardActions.fetchFailed();
  }
}

async function fetchDashboardCalendar(
  env, 
  actions, 
  startDate, 
  endDate, 
  teamLead, 
  calendarPageMode = PageModeCalendar.operators,  
  calendarDateMode = DateModeCalendar.days
) {
  try {
    let calendarReport = await env.api.calendar2.fetchCalendar(
        calendarPageMode,
        calendarDateMode,
        startDate.unix(),
        endDate.unix(),
        teamLead
      );

      actions.dashboardActions.fetchCalendarSuccess(calendarReport);

  } catch (error) {
      console.error(error);
      actions.dashboardActions.fetchFailed();
  }
}

async function fetchDashboardUsers(env, actions, startDate, endDate, teamLead) {
  try {
    let dashboardUsers = await env.api.dashboard.fetchDashboardUsers(
        startDate.unix(),
        endDate.unix(),
        teamLead
      )

      actions.dashboardActions.fetchUsersSuccess(dashboardUsers);

  } catch (error) {
      console.error(error);
      actions.dashboardActions.fetchFailed();
  }
}

async function fetchDashboardClients(env, actions, startDate, endDate, teamLead) {
  try {
    let dashboardClients = await env.api.dashboard.fetchDashboardClients(
        startDate.unix(),
        endDate.unix(),
        teamLead
      )

      actions.dashboardActions.fetchClientsSuccess(dashboardClients);

  } catch (error) {
      console.error(error);
      actions.dashboardActions.fetchFailed();
  }
}


addSideEffects(fetchDashboard, async (payload, { actions, store, env }) => {

  const { startDate, endDate, teamLead } = store.dashboard.filters;
  try {

    let previousStartDate = startDate.clone().subtract(1, 'months');
    let previousEndDate = endDate.clone().subtract(1, 'months');

    Promise.all([
      fetchDashboardData(env, actions, startDate, endDate, teamLead, previousStartDate, previousEndDate),
      fetchDashboardProfit(env, actions, startDate, endDate, teamLead, previousStartDate, previousEndDate),
      fetchDashboardCalendar(env, actions, startDate, endDate, teamLead),
      fetchDashboardUsers(env, actions, startDate, endDate, teamLead),
      fetchDashboardClients(env, actions, startDate, endDate, teamLead)
    ]);

    actions.dashboardActions.fetchSuccess();
  } catch (e) {
    console.error(e);
    actions.dashboardActions.fetchFailed();
    throw e;
  }
});


addSideEffects(fetchNewDashboard, async ({ calendarPageMode,  calendarDateMode }, { actions, store, env }) => {

  const { startDate, endDate, teamLead } = store.dashboard.filters;
  try {

    let previousStartDate = startDate.clone().subtract(1, 'months');
    let previousEndDate = endDate.clone().subtract(1, 'months');

    if (!startDate.isSame(endDate, 'month')) {
      let timedelta = endDate.diff(startDate, 'milliseconds');
      previousStartDate = startDate.clone().subtract(timedelta).date(startDate.date());
      previousEndDate = previousStartDate.clone().add(timedelta).date(endDate.date());
    }

    Promise.all([
      fetchDashboardData(env, actions, startDate, endDate, teamLead, previousStartDate, previousEndDate),
      fetchDashboardProfit(env, actions, startDate, endDate, teamLead, previousStartDate, previousEndDate),
      fetchDashboardCalendar(env, actions, startDate, endDate, teamLead, calendarPageMode,  calendarDateMode),
      fetchDashboardUsers(env, actions, startDate, endDate, teamLead),
      fetchDashboardClients(env, actions, startDate, endDate, teamLead)
    ]);

    actions.dashboardActions.fetchSuccess();
  } catch (e) {
    console.error(e);
    actions.dashboardActions.fetchFailed();
    throw e;
  }
});


addSideEffects(setDates, async ({ startDate, endDate }, { env, store }) => {
  try {
    await env.storage.setItem('dashboard-dates', clone({ startDate, endDate }));
  } catch (e) {
    console.error(e);
    throw e;
  }  
});


addSideEffects(initAction, async (_, { actions, env, store }) => {
  const dates = await env.storage.getItem('dashboard-dates');

  if (dates) {
    await env.storage.setItem('dashboard-dates', clone({
      startDate: dates.startDate ? moment(dates.startDate) : null,
      endDate: dates.endDate ? moment(dates.endDate) : null
    }));
    return;
  }
});
